import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import ToolIcon from "../../ToolIcon/ToolIcon";
import { CapabilityTool } from "../../../models/tools";
import { IconSize } from "../../../models/iconSize";
import { ModeFilterDto, ToolFilterDto } from "../../../models/advancedFilters";

interface ToolsFilterOptionProps {
  options: ToolFilterDto[];
  value: ToolFilterDto[];
  onChange: (value: ToolFilterDto[]) => void;
  /** Access-mode options from backend. Rendered only when tools are selected and list is non-empty. */
  modeOptions: ModeFilterDto[];
  selectedMode: ModeFilterDto | null;
  onSelectedModeChange: (mode: ModeFilterDto | null) => void;
}

const ToolsFilterOption = ({
  options,
  value,
  onChange,
  modeOptions,
  selectedMode,
  onSelectedModeChange,
}: ToolsFilterOptionProps): JSX.Element => (
  <>
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.name}
      value={value}
      onChange={(_event, newValue) => onChange(newValue)}
      isOptionEqualToValue={(option, val) =>
        option.capabilityToolKey === val.capabilityToolKey
      }
      renderOption={(props, option) => (
        <li {...props} key={option.capabilityToolKey}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ToolIcon
              tool={option.capabilityToolKey as CapabilityTool}
              size={IconSize.Small}
            />
            {option.name}
          </Box>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Tools"
          placeholder="Select tools"
          size="small"
        />
      )}
    />

    {modeOptions.length > 0 && value.length > 0 && (
      <FormControl component="fieldset">
        <FormLabel
          component="legend"
          sx={{ color: "text.primary", "&.Mui-focused": { color: "text.primary" } }}
        >
          Mode
        </FormLabel>
        <RadioGroup
          row
          value={selectedMode?.id ?? ""}
          onChange={(e) => {
            const id = Number(e.target.value);
            onSelectedModeChange(modeOptions.find((m) => m.id === id) ?? null);
          }}
        >
          {modeOptions.map((mode) => (
            <FormControlLabel
              key={mode.id}
              value={mode.id}
              control={<Radio />}
              label={mode.name}
            />
          ))}
        </RadioGroup>
      </FormControl>
    )}
  </>
);

export default ToolsFilterOption;

